(() => {
  const formatMoney = (cents) => {
    const format = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    const value = (cents / 100).toFixed(2);
    const withCommas = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toLocaleString())
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, withCommas);
  };

  /* Header height, used to place the mobile menu and sticky panels */
  const header = document.querySelector('[data-header]');
  const setHeaderVars = () => {
    if (!header) return;
    const rect = header.getBoundingClientRect();
    document.documentElement.style.setProperty('--header-height', `${rect.height}px`);
    document.documentElement.style.setProperty('--header-bottom', `${rect.bottom}px`);
  };
  setHeaderVars();
  window.addEventListener('resize', setHeaderVars);
  window.addEventListener('scroll', setHeaderVars, { passive: true });

  /* Mobile menu: lock scrolling while open */
  const mobileNav = document.querySelector('[data-mobile-nav]');
  if (mobileNav) {
    mobileNav.addEventListener('toggle', () => {
      setHeaderVars();
      document.body.style.overflow = mobileNav.open ? 'hidden' : '';
    });
  }

  /* Search toggle */
  const searchToggle = document.querySelector('[data-search-toggle]');
  const searchPanel = document.querySelector('[data-search-panel]');
  if (searchToggle && searchPanel) {
    searchToggle.addEventListener('click', (event) => {
      event.preventDefault();
      searchPanel.hidden = !searchPanel.hidden;
      if (!searchPanel.hidden) searchPanel.querySelector('input[type=search]').focus();
      setHeaderVars();
    });
  }

  /* Announcement rotation */
  const announcement = document.querySelector('[data-announcement]');
  if (announcement) {
    const items = announcement.querySelectorAll('.announcement__item');
    if (items.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      let index = 0;
      setInterval(() => {
        items[index].classList.remove('is-active');
        index = (index + 1) % items.length;
        items[index].classList.add('is-active');
      }, 5000);
    }
  }

  /* Dialogs (size guide) */
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-open-dialog]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.openDialog);
      if (dialog && dialog.showModal) dialog.showModal();
      return;
    }
    if (event.target.closest('[data-close-dialog]')) {
      event.target.closest('dialog').close();
      return;
    }
    if (event.target.tagName === 'DIALOG') event.target.close();
  });

  /* Toast */
  const toast = document.getElementById('CartToast');
  let toastTimer;
  const showToast = (text) => {
    if (!toast) return;
    toast.querySelector('.toast__text').textContent = text;
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { toast.hidden = true; }, 5000);
  };

  const updateCartCount = (count) => {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
    });
  };

  /* Product page: options, variant switching, add to bag */
  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const jsonEl = section.querySelector('[data-product-json]');
    if (!jsonEl) return;
    const product = JSON.parse(jsonEl.textContent);
    const form = section.querySelector('[data-product-form]');
    const idInput = section.querySelector('[data-variant-id]');
    const addButton = section.querySelector('[data-add-button]');
    const priceEl = section.querySelector('[data-price]');
    const stockMessage = section.querySelector('[data-stock-message]');
    const errorEl = section.querySelector('[data-form-error]');
    const installmentsInput = document.querySelector('#ProductInstallments input[name="id"]');

    const selectedOptions = () =>
      Array.from(section.querySelectorAll('[data-option-index]')).map((fieldset) => {
        const checked = fieldset.querySelector('input:checked');
        return checked ? checked.value : null;
      });

    const findVariant = (options) =>
      product.variants.find((variant) => variant.options.every((value, i) => value === options[i]));

    const refreshAvailability = (options) => {
      section.querySelectorAll('[data-option-index]').forEach((fieldset) => {
        const index = Number(fieldset.dataset.optionIndex);
        fieldset.querySelectorAll('input').forEach((input) => {
          const candidate = options.slice();
          candidate[index] = input.value;
          const match = product.variants.find((variant) =>
            variant.options.every((value, i) => i === index ? value === input.value : (options[i] === null || value === candidate[i]))
          );
          const label = fieldset.querySelector(`label[for="${input.id}"]`);
          if (label) label.classList.toggle('is-unavailable', !match || !match.available);
        });
        const selectedLabel = fieldset.querySelector('[data-option-selected]');
        if (selectedLabel) selectedLabel.textContent = options[index] || '';
      });
    };

    const renderPrice = (variant) => {
      if (!priceEl) return;
      const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      priceEl.classList.toggle('price--sale', !!onSale);
      priceEl.innerHTML =
        `<span class="price__current">${formatMoney(variant.price)}</span>` +
        (onSale ? `<s class="price__compare"><span class="visually-hidden">Was </span>${formatMoney(variant.compare_at_price)}</s>` : '');
    };

    const onChange = () => {
      const options = selectedOptions();
      const variant = findVariant(options);
      refreshAvailability(options);
      if (errorEl) errorEl.hidden = true;

      if (!variant) {
        if (addButton) { addButton.disabled = true; addButton.textContent = 'Unavailable'; }
        if (stockMessage) stockMessage.textContent = '';
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (installmentsInput) {
        installmentsInput.value = variant.id;
        installmentsInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.textContent = variant.available ? 'Add to bag' : 'Sold out';
      }
      if (stockMessage) stockMessage.textContent = variant.available ? '' : 'This size is sold out. Try another size or check back soon.';
      renderPrice(variant);

      if (variant.featured_media) {
        const media = section.querySelector(`[data-media-id="${variant.featured_media.id}"]`);
        const gallery = section.querySelector('[data-gallery]');
        if (media && gallery && media !== gallery.firstElementChild) gallery.prepend(media);
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    };

    section.querySelectorAll('[data-option-index] input').forEach((input) => input.addEventListener('change', onChange));
    if (section.querySelector('[data-option-index]')) refreshAvailability(selectedOptions());

    section.querySelectorAll('[data-qty]').forEach((button) => {
      button.addEventListener('click', () => {
        const input = button.parentElement.querySelector('input');
        input.value = Math.max(1, Number(input.value || 1) + Number(button.dataset.qty));
      });
    });

    if (form && window.fetch) {
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (addButton) { addButton.disabled = true; addButton.textContent = 'Adding...'; }
        try {
          const response = await fetch(`${window.theme.routes.cartAdd}.js`, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form),
          });
          const data = await response.json();
          if (!response.ok) throw new Error(data.description || data.message || 'Could not add to bag');
          const cart = await fetch(`${window.theme.routes.cart}.js`).then((r) => r.json());
          updateCartCount(cart.item_count);
          showToast(`Added ${data.product_title}${data.variant_title ? ` (${data.variant_title})` : ''}`);
        } catch (error) {
          if (errorEl) { errorEl.textContent = error.message; errorEl.hidden = false; }
        } finally {
          if (addButton) { addButton.disabled = false; addButton.textContent = 'Add to bag'; }
          onChange();
        }
      });
    }
  });

  /* Related products, loaded after the page */
  document.querySelectorAll('[data-recommendations]').forEach(async (el) => {
    try {
      const html = await fetch(el.dataset.url).then((r) => r.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
    } catch (e) { /* recommendations are optional */ }
  });

  /* Filters and sort: apply on change */
  const facetForm = document.querySelector('[data-facet-form]');
  if (facetForm) {
    const submit = () => {
      const params = new URLSearchParams();
      new FormData(facetForm).forEach((value, key) => { if (value !== '') params.append(key, value); });
      window.location.search = params.toString();
    };
    let priceTimer;
    facetForm.addEventListener('change', (event) => {
      if (event.target.type === 'number') {
        clearTimeout(priceTimer);
        priceTimer = setTimeout(submit, 600);
      } else {
        submit();
      }
    });
    facetForm.addEventListener('submit', (event) => { event.preventDefault(); submit(); });

    const drawer = facetForm.querySelector('[data-facet-drawer]');
    if (drawer) {
      document.addEventListener('click', (event) => {
        if (drawer.open && !drawer.contains(event.target)) drawer.open = false;
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && drawer.open) { drawer.open = false; drawer.querySelector('summary').focus(); }
      });
    }
  }

  /* Cart quantity: update on change */
  const cartForm = document.getElementById('CartForm');
  if (cartForm) {
    cartForm.querySelectorAll('[data-cart-qty]').forEach((input) => {
      input.addEventListener('change', async () => {
        const updates = Array.from(cartForm.querySelectorAll('[data-cart-qty]')).map((el) => Number(el.value));
        await fetch(`${window.theme.routes.cart}/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates }),
        });
        window.location.reload();
      });
    });
  }
})();

/* Yotpo (Swell) sign-up pop-up: its content lives in a same-origin iframe, so the theme's
   fonts and colours are injected into it. The two Yotpo tabs are placed side by side. */
(() => {
  const css = (v) => `
    ${v.fonts}
    html, body { background: ${v.bg} !important; height: auto !important; overflow: hidden; }
    #swell-popup-items-container {
      display: flex !important; flex-direction: column; justify-content: flex-start; gap: 14px;
      box-sizing: border-box; height: auto !important; padding: 44px clamp(20px, 7vw, 44px) 32px;
    }
    #swell-popup-items-container::before {
      content: "Newsletter"; text-align: center; font-family: ${v.body}; font-size: 11px;
      letter-spacing: .18em; text-transform: uppercase; color: ${v.muted};
    }
    .swell-popup-item-wrapper { position: static !important; width: auto !important; height: auto !important; }
    [swell-item-name="Header"] {
      font-family: ${v.heading} !important; font-weight: 500 !important; color: ${v.text} !important;
      font-size: clamp(26px, 6vw, 34px) !important; line-height: 1.15 !important; letter-spacing: .01em; text-wrap: balance;
    }
    [swell-item-name="Description"] {
      font-family: ${v.body} !important; color: ${v.muted} !important; font-size: 15px !important; line-height: 1.5 !important;
      margin-bottom: 6px;
    }
    .swell-input-item {
      height: 50px !important; width: 100% !important; padding: 0 16px !important; text-align: left !important;
      font-family: ${v.body} !important; font-size: 15px !important; color: ${v.text} !important;
      background: #fff !important; border: 1px solid ${v.line} !important; border-radius: 0 !important; outline: none;
    }
    .swell-input-item:focus { border-color: ${v.text} !important; }
    .swell-button-item {
      height: 50px !important; width: 100% !important; border: 0 !important; border-radius: 0 !important;
      background: ${v.text} !important; color: ${v.bg} !important; cursor: pointer;
      font-family: ${v.body} !important; font-size: 12px !important; font-weight: 500 !important;
      letter-spacing: .16em !important; text-transform: uppercase !important;
    }
    .swell-button-item:hover { opacity: .88; }
    #swell-popup-close { background: transparent !important; top: 12px !important; right: 12px !important; }
    #swell-popup-close-x { color: ${v.text} !important; }
    #swell-check { color: ${v.text} !important; }
  `;

  const themeVars = () => {
    const root = getComputedStyle(document.documentElement);
    const get = (name) => root.getPropertyValue(name).trim();
    const fonts = Array.from(document.querySelectorAll('style'))
      .flatMap((s) => s.textContent.match(/@font-face\s*{[^}]*}/g) || [])
      .join('\n');
    return {
      fonts, bg: get('--color-bg'), text: get('--color-text'), muted: get('--color-muted'),
      line: get('--color-line'), heading: get('--font-heading'), body: get('--font-body'),
    };
  };

  const styleSwell = () => {
    const frame = document.getElementById('swell-popup');
    let doc = null;
    try { doc = frame && frame.contentDocument; } catch (e) { doc = null; }
    if (doc && doc.head && doc.getElementById('swell-popup-items-container') && !doc.getElementById('chakra-swell')) {
      const style = doc.createElement('style');
      style.id = 'chakra-swell';
      style.textContent = css(themeVars());
      doc.head.appendChild(style);
    }
    const items = doc && doc.getElementById('swell-popup-items-container');
    if (items && doc.getElementById('chakra-swell') && items.offsetHeight > 0) {
      frame.style.setProperty('height', `${items.offsetHeight}px`, 'important');
    }

    let left = 24;
    document.querySelectorAll('.swell-tab').forEach((tab) => {
      if (getComputedStyle(tab).display === 'none') return;
      tab.style.setProperty('left', `${left}px`, 'important');
      left += tab.offsetWidth + 8;
    });
  };

  const timer = setInterval(styleSwell, 600);
  setTimeout(() => clearInterval(timer), 120000);
})();
